<header class="bg-white h-20 flex items-center justify-between px-6 lg:px-10 shadow-sm border-b border-gray-100 sticky top-0 z-40">

  <div class="flex items-center gap-4">
    <button (click)="menuService.toggle()" class="lg:hidden text-[#1e3a8a] hover:bg-blue-50 p-2 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-[#ffb31c]">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>

    <div class="hidden md:block">
      <h2 class="text-xl font-black text-[#1e3a8a] tracking-wide">Panel de Control</h2>
      <p class="text-xs text-gray-500 font-medium">Sistema de Gestión Integrado RMS</p>
    </div>
  </div>

  <div class="flex items-center gap-4 sm:gap-6">

    <button class="relative p-2 text-gray-400 hover:text-[#1e3a8a] transition-colors rounded-full hover:bg-gray-50 focus:outline-none">
      <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
      </svg>
      <span class="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white"></span>
    </button>

    <div class="h-8 w-px bg-gray-200 hidden sm:block"></div>

    <div class="flex items-center gap-3 cursor-pointer group">
      <div class="text-right hidden sm:block">
        <p class="text-sm font-bold text-[#1e3a8a] leading-tight group-hover:text-[#ffb31c] transition-colors">
          {{ authService.usuarioActual()?.nombre || 'Cargando...' }}
        </p>
        <p class="text-[10px] text-gray-400 font-black uppercase tracking-tighter leading-tight">
          Personal Autorizado
        </p>
      </div>

      <div class="w-10 h-10 rounded-full border-2 border-[#ffb31c] shadow-sm overflow-hidden bg-gray-100 flex items-center justify-center transition-transform group-hover:scale-105">
        @if (authService.usuarioActual()?.fotoUrl) {
          <img [src]="authService.usuarioActual()?.fotoUrl"
               referrerpolicy="no-referrer"
               alt="Perfil"
               class="w-full h-full object-cover">
        } @else {
          <img [src]="'https://ui-avatars.com/api/?name=' + (authService.usuarioActual()?.nombre || 'U') + '&background=1e3a8a&color=fff'"
               alt="Avatar"
               class="w-full h-full object-cover">
        }
      </div>
    </div>

    <button (click)="logout()" class="flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2.5 rounded-xl text-sm font-bold hover:bg-red-600 hover:text-white transition-all group shadow-sm">
      <span class="hidden sm:block">Salir</span>
      <svg class="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
      </svg>
    </button>

  </div>
</header>
